import * as yup from "yup";
const passwordRules = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{5,}$/;
export const LoginSchema = yup.object().shape({
  email: yup.string().required("Email Required"),
  password: yup.string().required("Password Required")
});
